import { useTranslations } from 'next-intl';

import BookingValueBloc from '../../blocs/booking-value-bloc';
import { useObservableState } from '@nf/utils-common/hooks';
import { addCommasWithFix } from '@/utils/odds-utils';
import { reservationService } from '../../services/reservation.service';
import { useBookingOddsType } from '../../hooks/use-booking-odds-type';

import clsx from 'clsx';
import { betslipStyle } from '@/features/betslip/betslip.style';

interface BookingPayoutProps {
	oddsMinValueBloc: BookingValueBloc;
	oddsMaxValueBloc: BookingValueBloc;
	ticketStake: number;
	ticketPriceType: number;
}

export const BookingPayout = ({  
	oddsMinValueBloc, 
	oddsMaxValueBloc,
	ticketStake,
	ticketPriceType
}: BookingPayoutProps) => {
	const t = useTranslations('General');
	const { bookingOddsType } = useBookingOddsType(ticketPriceType);
	const bookingMinValue = useObservableState(oddsMinValueBloc.bookingValue$);
	const bookingMaxValue = useObservableState(oddsMaxValueBloc.bookingValue$);
	const oddsMinValue = bookingMinValue?.expectedValue ?? 0;
	const oddsMaxValue = bookingMaxValue?.expectedValue ?? 0;

	const [minPayout, maxPayout] = reservationService.calculatePayoutRange({
		oddsRange: [oddsMinValue, oddsMaxValue],
		ticketStake,
		bookingOddsType,
		ticketPriceType
	});

	return minPayout > 0 && maxPayout > 0 ? (
		<div className="bet-slip__payout">
			{`${t('lbl_payout')}: `}
			<strong className={clsx('bet-slip__payout-amount', betslipStyle.textSecondary)}>
				{addCommasWithFix(minPayout, 2)}
				{' ~ '}
				{addCommasWithFix(maxPayout, 2)}
			</strong>
		</div>
	) : null;
};